import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTarget, FiTrendingUp, FiShield, FiUsers } = FiIcons;

const AboutSection = () => {
  const features = [
    {
      icon: FiTarget,
      title: "Specialized Focus",
      description: "Exclusively serving HVAC and plumbing companies"
    },
    {
      icon: FiTrendingUp,
      title: "Proven Results",
      description: "Successful exits for companies $1M-$25M in revenue"
    },
    {
      icon: FiShield,
      title: "Confidential Process",
      description: "Your business information stays secure throughout"
    },
    {
      icon: FiUsers,
      title: "Expert Guidance",
      description: "Dedicated advisors who understand your industry"
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            About HVAC Biz Broker
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-xl text-gray-600 leading-relaxed">
              HVAC Biz Broker is dedicated to advising HVAC owners through successful exits. 
              We specialize in HVAC and plumbing companies with $1M–$25M in revenue, providing 
              expert guidance and connecting you with qualified buyers who understand the value 
              of your business.
            </p>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center p-6 rounded-lg hover:shadow-lg transition-shadow duration-300"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 text-blue-600 rounded-full mb-4">
                <SafeIcon icon={feature.icon} className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;